/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: number; output: number; }
  Long: { input: number; output: number; }
  Void: { input: any; output: any; }
};

export type AccessConstraint = {
  partyRole?: InputMaybe<PartyRole>;
};

export type Address = {
  /** city is used for the city/town/village of the address */
  city?: Maybe<Scalars['String']['output']>;
  /** ISO country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  long?: Maybe<Scalars['Float']['output']>;
  /** postal identifier for the address */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** region is the state, region, or any other subdivision of the country */
  region?: Maybe<Scalars['String']['output']>;
  /** street contains the housing number and street name */
  street?: Maybe<Scalars['String']['output']>;
  /** street_additional is used for any other additional street identifying information */
  streetAdditional?: Maybe<Scalars['String']['output']>;
};

export enum AffiliateType {
  Accounting = 'Accounting',
  Investment = 'Investment'
}

export type AppInstanceProfile = {
  appBundleId: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  appVersion: Scalars['String']['input'];
  deviceModel: Scalars['String']['input'];
  deviceName: Scalars['String']['input'];
  deviceOs: Scalars['String']['input'];
  deviceOsVersion: Scalars['String']['input'];
};

export enum ArrivalContext {
  ClientPays = 'ClientPays',
  ClientPaysComposable = 'ClientPaysComposable',
  ReportsBuilder = 'ReportsBuilder',
  ResetClientPays = 'ResetClientPays',
  TransactionReview = 'TransactionReview'
}

export type BankAccount = {
  accountIdMask: Scalars['String']['output'];
  iconObjectName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  isAutoPayout: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
};

export type BillPaymentPreview = {
  amount: MonetaryValue;
  billId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  image: BillPaymentPreviewSegment;
  payerCompanyName: Scalars['String']['output'];
  payerEmailAddress: Scalars['String']['output'];
  vendor: PartyPreview;
};

export type BillPaymentPreviewSegment = {
  collectionId: Scalars['String']['output'];
  fileId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CategoryPreview = {
  displayKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: CategoryType;
};

export enum CategoryType {
  Assets = 'Assets',
  CostOfGoodsSold = 'CostOfGoodsSold',
  Equity = 'Equity',
  Expenses = 'Expenses',
  Income = 'Income',
  Liabilities = 'Liabilities',
  OtherExpenses = 'OtherExpenses',
  OtherIncome = 'OtherIncome',
  UnknownType = 'UnknownType'
}

export type Contact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
};

export type ContactInput = {
  emailAddress: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type CreditCard = {
  /** Card brand (e.g., visa, mastercard, amex) */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Expiration month (1-12) */
  cardExpiryMonth?: Maybe<Scalars['Long']['output']>;
  /** Expiration year (e.g., 2025) */
  cardExpiryYear?: Maybe<Scalars['Long']['output']>;
  /** Last 4 digits of the card number */
  cardLastFour?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  nickname: Scalars['String']['output'];
};

export type Customer = {
  address?: Maybe<CustomerAddress>;
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerType: ProviderType;
};

export type CustomerAddress = {
  address?: Maybe<Address>;
  id: Scalars['String']['output'];
};

export type CustomerSummary = {
  email: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Date = {
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type DateInput = {
  day?: InputMaybe<Scalars['Int']['input']>;
  month?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Discount = {
  categoryId?: Maybe<Scalars['String']['output']>;
  dataSourceId?: Maybe<Scalars['String']['output']>;
  discountId: Scalars['String']['output'];
  fixedDiscountAmount?: Maybe<MonetaryValue>;
  name: Scalars['String']['output'];
  providerType: ProviderType;
  variablePercentage?: Maybe<Scalars['Float']['output']>;
};

export enum DisplayEntry {
  Credit = 'Credit',
  Debit = 'Debit',
  TransferCredit = 'TransferCredit',
  TransferDebit = 'TransferDebit',
  Unknown = 'Unknown'
}

export type DocumentDownload = {
  url: Scalars['String']['output'];
};

export type EmployeeLegalEntityRole = {
  legalEntityId: Scalars['String']['output'];
  role?: Maybe<Role>;
};

export type EntityLegalEntity = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityOrganization = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type EntityUser = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName: Scalars['String']['output'];
  givenName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum Flow {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  UnknownFlow = 'UnknownFlow'
}

export type Identity = {
  domain?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['String']['output'];
  provider: OAuthService;
};

export type InputMonetaryValue = {
  amount: Scalars['Long']['input'];
  currencyMultiplier: Scalars['Long']['input'];
  iso4217CurrencyCode: Scalars['String']['input'];
};

/**
 * ObjectIdentifier is a generic identifier with an enumerated kind.
 * It can be used to identify different Digits' core objects.
 */
export type InputObjectIdentifier = {
  id: Scalars['String']['input'];
  kind: ObjectKind;
  legalEntityId: Scalars['String']['input'];
};

export type InputQuantityValue = {
  quantity: Scalars['Long']['input'];
  quantityMultiplier: Scalars['Long']['input'];
};

export enum Interval {
  Biweek = 'Biweek',
  Day = 'Day',
  Hour = 'Hour',
  IntervalNone = 'IntervalNone',
  Minute = 'Minute',
  Month = 'Month',
  Quarter = 'Quarter',
  Week = 'Week',
  Year = 'Year'
}

export type Invitation = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  invitationType: InvitationType;
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  recipient: Contact;
  role?: Maybe<Role>;
  sender?: Maybe<Contact>;
  service?: Maybe<OAuthService>;
  signupId?: Maybe<Scalars['String']['output']>;
  status: InvitationStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type InvitationProposal = {
  createdAt: Scalars['DateTime']['output'];
  invitationId: Scalars['String']['output'];
  legalEntity?: Maybe<EntityLegalEntity>;
  organization?: Maybe<EntityOrganization>;
  organizationTemplateId?: Maybe<Scalars['String']['output']>;
  proposalId: Scalars['String']['output'];
  proposalType: ProposalType;
  recipient?: Maybe<Contact>;
  sender?: Maybe<EntityUser>;
  status: InvitationProposalStatus;
};

export enum InvitationProposalStatus {
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Rejected = 'Rejected',
  Sent = 'Sent',
  Unknown = 'Unknown'
}

export enum InvitationStatus {
  Accepted = 'Accepted',
  Active = 'Active',
  Cancelled = 'Cancelled',
  Unknown = 'Unknown'
}

export type InvitationToken = {
  token: Scalars['String']['output'];
};

export enum InvitationType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  Passwordless = 'Passwordless',
  UnknownType = 'UnknownType'
}

export type Invoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  status: InvoiceStatus;
  statusSummary?: Maybe<InvoiceStatusSummary>;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type InvoiceBranding = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  coverURL?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type InvoiceDiscount = {
  amount: MonetaryValue;
  discount: Discount;
  discountAmount?: Maybe<MonetaryValue>;
  invoiceDiscountId: Scalars['String']['output'];
};

export type InvoiceFile = {
  documentId: Scalars['String']['output'];
  fileType?: Maybe<InvoiceFileType>;
};

export enum InvoiceFileType {
  InvoicePDF = 'InvoicePDF',
  Unknown = 'Unknown'
}

export type InvoiceLineItem = {
  amount: MonetaryValue;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Long']['output'];
  productId?: Maybe<Scalars['String']['output']>;
  quantityValue?: Maybe<QuantityValue>;
  sku?: Maybe<Scalars['String']['output']>;
  taxable: Scalars['Boolean']['output'];
  unitPrice: MonetaryValue;
};

export type InvoiceNumber = {
  invoiceNumber: Scalars['String']['output'];
};

export type InvoicePaymentDetails = {
  paymentAmount: MonetaryValue;
  paymentConfirmationId: Scalars['String']['output'];
  paymentDate: Scalars['DateTime']['output'];
  paymentInstrument: PaymentInstrument;
};

export enum InvoiceStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  /** adding this temporarily to fix an ops issue */
  Draft = 'Draft',
  Failed = 'Failed',
  ManuallySent = 'ManuallySent',
  MarkedAsPaid = 'MarkedAsPaid',
  OnHold = 'OnHold',
  Paid = 'Paid',
  PaymentCanceled = 'PaymentCanceled',
  PaymentProcessing = 'PaymentProcessing',
  PaymentRejected = 'PaymentRejected',
  PaymentRequiresAttention = 'PaymentRequiresAttention',
  PaymentReturned = 'PaymentReturned',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Sent = 'Sent',
  Settled = 'Settled',
  Submitted = 'Submitted',
  Unknown = 'Unknown',
  UnspecifiedBillStatus = 'UnspecifiedBillStatus',
  Voided = 'Voided'
}

export type InvoiceStatusSummary = {
  internalNoteForStatus?: Maybe<Scalars['String']['output']>;
  invoiceSentDate: Scalars['DateTime']['output'];
  status: InvoiceStatus;
  statusAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoicingAddress = {
  address: Address;
  id: Scalars['String']['output'];
};

export type InvoicingProfile = {
  companyAddress: InvoicingAddress;
  companyEmail: Scalars['String']['output'];
  companyIcon?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  finalized?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  invoiceNumberFormat?: Maybe<Scalars['String']['output']>;
  invoiceNumberFormatDefault: Scalars['String']['output'];
  payoutInstrumentID: Scalars['String']['output'];
};

export type LedgerBillPreview = {
  amount: MonetaryValue;
  billId: Scalars['String']['output'];
  dueDate?: Maybe<Date>;
  externalId: Scalars['String']['output'];
  image?: Maybe<BillPaymentPreviewSegment>;
  invoiceDate?: Maybe<Date>;
  payerCompanyName: Scalars['String']['output'];
  payerEmailAddress: Scalars['String']['output'];
  vendor: LedgerBillPreviewVendor;
};

export type LedgerBillPreviewVendor = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LegalEntityRoleOptions = {
  legalEntityId: Scalars['String']['output'];
  legalEntityRoles: Array<Role>;
  organizationRoles: Array<Role>;
};

export enum LegalEntityStatus {
  Active = 'Active',
  Approved = 'Approved',
  New = 'New',
  Pending = 'Pending',
  PendingHold = 'PendingHold',
  Removed = 'Removed',
  Unknown = 'Unknown'
}

export enum MetricType {
  COGS = 'COGS',
  Expenses = 'Expenses',
  GrossProfit = 'GrossProfit',
  Income = 'Income',
  NetIncome = 'NetIncome',
  NetOperatingIncome = 'NetOperatingIncome',
  ProfitPercentage = 'ProfitPercentage'
}

export enum MfaMethod {
  RecoveryCode = 'RecoveryCode',
  TOTP = 'TOTP',
  UnknownMfaMethod = 'UnknownMfaMethod'
}

/** MonetaryValue */
export type MonetaryValue = {
  amount: Scalars['Long']['output'];
  currencyMultiplier: Scalars['Long']['output'];
  iso4217CurrencyCode: Scalars['String']['output'];
};

export type MoneyFlow = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['output'];
  value: MonetaryValue;
};

export type MoneyFlowInput = {
  businessFlow: Flow;
  isNormal: Scalars['Boolean']['input'];
  value: InputMonetaryValue;
};

export type Mutation = {
  logInSuperuser: Session;
  logOut?: Maybe<Scalars['Void']['output']>;
  tokenRefresh: Session;
};


export type MutationLogInSuperuserArgs = {
  code: Scalars['String']['input'];
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  service: OAuthService;
};

export enum OAuthService {
  Google = 'Google',
  LinkedIn = 'LinkedIn',
  QuickBooks = 'QuickBooks',
  Unknown = 'Unknown'
}

export enum ObjectKind {
  Bill = 'Bill',
  Category = 'Category',
  Comment = 'Comment',
  Connection = 'Connection',
  DataSource = 'DataSource',
  Department = 'Department',
  Discount = 'Discount',
  Invoice = 'Invoice',
  LedgerTransaction = 'LedgerTransaction',
  LegalEntity = 'LegalEntity',
  Location = 'Location',
  Party = 'Party',
  Portal = 'Portal',
  Product = 'Product',
  Reconciliation = 'Reconciliation',
  Report = 'Report',
  ReportPackage = 'ReportPackage',
  Schedule = 'Schedule',
  Thread = 'Thread',
  Transaction = 'Transaction',
  User = 'User',
  WorkItem = 'WorkItem'
}

export type Organization = {
  branding?: Maybe<OrganizationBranding>;
  displayId?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
};

export type OrganizationEmployment = {
  employeeId: Scalars['String']['output'];
  legalEntityRoles?: Maybe<Array<EmployeeLegalEntityRole>>;
  organization: Organization;
  role: Role;
};

export enum OrganizationKind {
  AccountingFirm = 'AccountingFirm',
  Developer = 'Developer',
  Operator = 'Operator',
  SandboxAccountingFirm = 'SandboxAccountingFirm',
  SandboxOperator = 'SandboxOperator',
  UnknownKind = 'UnknownKind'
}

export type OrganizationPreferences = {
  anonymizeEmployees: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
};

export type OrganizationTemplate = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PartyPreview = {
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum PartyRole {
  EntityAssetRole = 'EntityAssetRole',
  EntityAssetSupplierRole = 'EntityAssetSupplierRole',
  EntityAssetVendorRole = 'EntityAssetVendorRole',
  EntityBanksRole = 'EntityBanksRole',
  EntityCreditCardsRole = 'EntityCreditCardsRole',
  EntityCustomerRole = 'EntityCustomerRole',
  EntityDebtorRole = 'EntityDebtorRole',
  EntityInvesteeRole = 'EntityInvesteeRole',
  EntityLenderRole = 'EntityLenderRole',
  EntityLiabilitiesRole = 'EntityLiabilitiesRole',
  EntityOtherExpensesRole = 'EntityOtherExpensesRole',
  EntityOtherIncomeRole = 'EntityOtherIncomeRole',
  EntityOtherLiabilitiesRole = 'EntityOtherLiabilitiesRole',
  EntityOwedVendorRole = 'EntityOwedVendorRole',
  EntityPrepaidVendorRole = 'EntityPrepaidVendorRole',
  EntityProcessorRole = 'EntityProcessorRole',
  EntityRevenuePartnerRole = 'EntityRevenuePartnerRole',
  EntityShareholderRole = 'EntityShareholderRole',
  EntitySupplierRole = 'EntitySupplierRole',
  EntityUnpaidCustomerRole = 'EntityUnpaidCustomerRole',
  EntityUnspecifiedRole = 'EntityUnspecifiedRole',
  EntityVendorRole = 'EntityVendorRole',
  FacilitatorRole = 'FacilitatorRole',
  InstitutionCreditRole = 'InstitutionCreditRole',
  InstitutionDebitRole = 'InstitutionDebitRole',
  OwnerRole = 'OwnerRole',
  PaymentProcessorRole = 'PaymentProcessorRole',
  UnknownRole = 'UnknownRole'
}

export type PayInvoiceSummary = {
  invoicePaymentDetails: InvoicePaymentDetails;
  status: InvoiceStatus;
};

export type PaymentInstrument = BankAccount | CreditCard;

export enum PaymentStatus {
  Blocked = 'Blocked',
  Canceled = 'Canceled',
  Created = 'Created',
  Deposited = 'Deposited',
  Held = 'Held',
  Mailed = 'Mailed',
  OnHold = 'OnHold',
  Paid = 'Paid',
  Pending = 'Pending',
  PendingApproval = 'PendingApproval',
  PendingIncreaseReview = 'PendingIncreaseReview',
  PendingMailing = 'PendingMailing',
  PendingSubmission = 'PendingSubmission',
  ProcessingReturn = 'ProcessingReturn',
  ProcessingSettlement = 'ProcessingSettlement',
  Refunded = 'Refunded',
  Rejected = 'Rejected',
  RequiresAttention = 'RequiresAttention',
  Returned = 'Returned',
  Settled = 'Settled',
  Stopped = 'Stopped',
  Submitted = 'Submitted',
  Unknown = 'Unknown'
}

export type Period = {
  endedAt: Scalars['DateTime']['output'];
  interval: Interval;
  name: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type PeriodInput = {
  endedAt: Scalars['DateTime']['input'];
  interval: Interval;
  name: Scalars['String']['input'];
  startedAt: Scalars['DateTime']['input'];
};

export enum ProposalType {
  AffiliateInviteManagedOperator = 'AffiliateInviteManagedOperator',
  AffiliationAssistClient = 'AffiliationAssistClient',
  AffiliationCreateClient = 'AffiliationCreateClient',
  AffiliationJoinClient = 'AffiliationJoinClient',
  CreateOrganization = 'CreateOrganization',
  EmploymentAssistOperator = 'EmploymentAssistOperator',
  EmploymentJoinOrg = 'EmploymentJoinOrg',
  EnterprisePackageInvite = 'EnterprisePackageInvite',
  OperatorAssistAffiliate = 'OperatorAssistAffiliate',
  UnknownProposalType = 'UnknownProposalType'
}

export enum ProviderType {
  CSVImport = 'CSVImport',
  Connect = 'Connect',
  Derived = 'Derived',
  Digits = 'Digits',
  DigitsInvoicing = 'DigitsInvoicing',
  DigitsLedgerInvoicing = 'DigitsLedgerInvoicing',
  DigitsLedgerPay = 'DigitsLedgerPay',
  DigitsPay = 'DigitsPay',
  DigitsPaymentsLedger = 'DigitsPaymentsLedger',
  DigitsSchedule = 'DigitsSchedule',
  Manual = 'Manual',
  Plaid = 'Plaid',
  QuickBooks = 'QuickBooks',
  UnknownProvider = 'UnknownProvider',
  Xero = 'Xero'
}

export type PublicInvoice = {
  branding: InvoiceBranding;
  customer?: Maybe<Customer>;
  discounts?: Maybe<Array<InvoiceDiscount>>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  files?: Maybe<Array<InvoiceFile>>;
  id: Scalars['String']['output'];
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  invoicingProfile?: Maybe<InvoicingProfile>;
  legalEntityId: Scalars['String']['output'];
  lineItems: Array<InvoiceLineItem>;
  memo?: Maybe<Scalars['String']['output']>;
  receivableInvoiceId: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: InvoiceStatus;
  subtotal?: Maybe<MonetaryValue>;
  taxPercent?: Maybe<Scalars['Float']['output']>;
  totalAmount?: Maybe<MonetaryValue>;
  totalTax?: Maybe<MonetaryValue>;
};

export type QuantityValue = {
  quantity: Scalars['Long']['output'];
  quantityMultiplier: Scalars['Long']['output'];
};

export type Query = {
  void?: Maybe<Scalars['Void']['output']>;
};

export enum ReportKind {
  APAging = 'APAging',
  ARAging = 'ARAging',
  BalanceSheet = 'BalanceSheet',
  Budget = 'Budget',
  CashFlow = 'CashFlow',
  ExpenseSummary = 'ExpenseSummary',
  ProfitAndLoss = 'ProfitAndLoss',
  Unknown = 'Unknown'
}

export type ReportPackagePreview = {
  author: EntityUser;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  interval: Interval;
  periodEndedAt: Scalars['DateTime']['output'];
  periodStartedAt: Scalars['DateTime']['output'];
  preparedBy?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type RequestParameter = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Role = {
  id: Scalars['String']['output'];
};

export type RoleIdentifier = {
  id: Scalars['String']['input'];
};

export enum SandboxIndustry {
  Retail = 'Retail',
  Technology = 'Technology',
  UnknownIndustry = 'UnknownIndustry'
}

export enum SandboxType {
  Accountant = 'Accountant',
  Operator = 'Operator',
  UnknownSandboxType = 'UnknownSandboxType'
}

export type SentInvoiceUsers = {
  invoice: Invoice;
  users?: Maybe<Array<User>>;
};

export type Session = {
  bearer: Scalars['String']['output'];
  employments?: Maybe<Array<SessionEmployment>>;
};

export type SessionAffiliation = {
  id: Scalars['String']['output'];
  kind?: Maybe<AffiliateType>;
  organization: SessionOrganization;
};

export enum SessionBillingMode {
  Billed = 'Billed',
  Included = 'Included',
  UnknownMode = 'UnknownMode'
}

export type SessionBillingPayer = {
  kind: SessionPayerKind;
  stripeSubscription: SessionSubscriptionStatus;
};

export type SessionEmployment = {
  affiliations: Array<SessionAffiliation>;
  id: Scalars['String']['output'];
  organization: SessionOrganization;
};

export type SessionLegalEntity = {
  affiliatedOrganizationIds: Array<Scalars['String']['output']>;
  aspects: Array<Scalars['String']['output']>;
  billing?: Maybe<SessionLegalEntityBilling>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: LegalEntityStatus;
  viewKeys: Array<SessionViewKey>;
};

export type SessionLegalEntityBilling = {
  payer: SessionBillingPayer;
  productCoverage?: Maybe<SessionProductCoverage>;
};

export type SessionOrganization = {
  aspects?: Maybe<Array<Scalars['String']['output']>>;
  /** Set only on the employing organization, not on affiliation organizations. */
  billing?: Maybe<SessionOrganizationBilling>;
  branding?: Maybe<SessionOrganizationBranding>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<OrganizationKind>;
  legalEntities: Array<SessionLegalEntity>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type SessionOrganizationBilling = {
  /**
   * True when the billing database has a Stripe subscription ID recorded for the
   * organization, live or not (Canceled and Incomplete keep their IDs). Not an
   * attach gate by itself: an Incomplete subscription has an ID but rejects
   * attachments, so combine this bit with stripeSubscription.
   */
  hasStripeSubscription: Scalars['Boolean']['output'];
  /**
   * Observed status. UnknownStatus with hasStripeSubscription true means the state
   * is not observed yet.
   */
  stripeSubscription: SessionSubscriptionStatus;
};

export type SessionOrganizationBranding = {
  headerColor: Scalars['String']['output'];
  headerTextColor: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum SessionPayerKind {
  AffiliatePaid = 'AffiliatePaid',
  SelfPaid = 'SelfPaid',
  UnknownKind = 'UnknownKind'
}

export type SessionProductCoverage = {
  legacy: Scalars['Boolean']['output'];
  mode: SessionBillingMode;
};

export enum SessionSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Incomplete = 'Incomplete',
  PastDue = 'PastDue',
  Trialing = 'Trialing',
  UnknownStatus = 'UnknownStatus',
  Unpaid = 'Unpaid'
}

export type SessionViewKey = {
  legalEntityId: Scalars['String']['output'];
  mutationVersion?: Maybe<Scalars['String']['output']>;
  viewType?: Maybe<ViewType>;
  viewVersion?: Maybe<Scalars['String']['output']>;
};

export type ShareObject = CategoryPreview | PartyPreview | ReportPackagePreview | TransactionPreview;

export type SharePreview = {
  legalEntity: EntityLegalEntity;
  object: ShareObject;
  /** Invited user email. */
  userEmail?: Maybe<Scalars['String']['output']>;
};

export enum SignupStatus {
  Applied = 'Applied',
  Approved = 'Approved',
  Ignored = 'Ignored',
  InviteAccepted = 'InviteAccepted',
  Invited = 'Invited',
  PrimerSent = 'PrimerSent',
  Qualified = 'Qualified',
  Unknown = 'Unknown',
  Unqualified = 'Unqualified',
  Waitlisted = 'Waitlisted'
}

export enum TaxStatus {
  NonTaxable = 'NonTaxable',
  Taxable = 'Taxable',
  Undetermined = 'Undetermined',
  UnspecifiedTaxStatus = 'UnspecifiedTaxStatus'
}

export type TransactionPreview = {
  creditCategory?: Maybe<CategoryPreview>;
  debitCategory?: Maybe<CategoryPreview>;
  description?: Maybe<Scalars['String']['output']>;
  displayEntry: DisplayEntry;
  name?: Maybe<Scalars['String']['output']>;
  party?: Maybe<PartyPreview>;
  timestamp: Scalars['DateTime']['output'];
};

export type User = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  employments?: Maybe<Array<OrganizationEmployment>>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  identities?: Maybe<Array<Identity>>;
  lastActivityAt: Scalars['DateTime']['output'];
  /** Timestamp when the user activated an MFA factor (e.g. TOTP). Null when no factor is enrolled. */
  mfaEnforcedAt?: Maybe<Scalars['DateTime']['output']>;
  passwordSet: Scalars['Boolean']['output'];
  primaryEmailAddress: Scalars['String']['output'];
};

export type UserContact = {
  avatarUrl?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export enum VerificationRequestDestination {
  AIAccounting = 'AIAccounting',
  Bill = 'Bill',
  Developer = 'Developer',
  LedgerBill = 'LedgerBill',
  ProspectFirm = 'ProspectFirm',
  Share = 'Share',
  StartBusiness = 'StartBusiness',
  StartDeveloper = 'StartDeveloper',
  StartFirm = 'StartFirm',
  StartUnknown = 'StartUnknown',
  Unspecified = 'Unspecified'
}

export type ViewInvoiceSummary = {
  creditCardsEnabled: Scalars['Boolean']['output'];
  invoice: PublicInvoice;
  invoicePaymentDetails?: Maybe<InvoicePaymentDetails>;
  isPayable: Scalars['Boolean']['output'];
  useNewPaymentProvider: Scalars['Boolean']['output'];
};

export type ViewKey = {
  legalEntityId: Scalars['String']['input'];
  mutationVersion?: InputMaybe<Scalars['String']['input']>;
  viewType?: InputMaybe<ViewType>;
  viewVersion?: InputMaybe<Scalars['String']['input']>;
};

export enum ViewType {
  AIBookkeeper = 'AIBookkeeper',
  Ledger = 'Ledger',
  Unknown = 'Unknown'
}

export type LoginSuperuserMutationVariables = Exact<{
  service: OAuthService;
  code: Scalars['String']['input'];
}>;


export type LoginSuperuserMutation = { logInSuperuser: Pick<Session, 'bearer'> };

export type TokenRefreshMutationVariables = Exact<{ [key: string]: never; }>;


export type TokenRefreshMutation = { tokenRefresh: Pick<Session, 'bearer'> };

export type LogOutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogOutMutation = Pick<Mutation, 'logOut'>;


export const LoginSuperuserDocument = gql`
    mutation LoginSuperuser($service: OAuthService!, $code: String!) {
  logInSuperuser(service: $service, code: $code) {
    bearer
  }
}
    `;
export type LoginSuperuserMutationFn = Apollo.MutationFunction<LoginSuperuserMutation, LoginSuperuserMutationVariables>;

/**
 * __useLoginSuperuserMutation__
 *
 * To run a mutation, you first call `useLoginSuperuserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSuperuserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSuperuserMutation, { data, loading, error }] = useLoginSuperuserMutation({
 *   variables: {
 *      service: // value for 'service'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useLoginSuperuserMutation(baseOptions?: Apollo.MutationHookOptions<LoginSuperuserMutation, LoginSuperuserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginSuperuserMutation, LoginSuperuserMutationVariables>(LoginSuperuserDocument, options);
      }
export type LoginSuperuserMutationHookResult = ReturnType<typeof useLoginSuperuserMutation>;
export type LoginSuperuserMutationResult = Apollo.MutationResult<LoginSuperuserMutation>;
export type LoginSuperuserMutationOptions = Apollo.BaseMutationOptions<LoginSuperuserMutation, LoginSuperuserMutationVariables>;
export const TokenRefreshDocument = gql`
    mutation TokenRefresh {
  tokenRefresh {
    bearer
  }
}
    `;
export type TokenRefreshMutationFn = Apollo.MutationFunction<TokenRefreshMutation, TokenRefreshMutationVariables>;

/**
 * __useTokenRefreshMutation__
 *
 * To run a mutation, you first call `useTokenRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTokenRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tokenRefreshMutation, { data, loading, error }] = useTokenRefreshMutation({
 *   variables: {
 *   },
 * });
 */
export function useTokenRefreshMutation(baseOptions?: Apollo.MutationHookOptions<TokenRefreshMutation, TokenRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TokenRefreshMutation, TokenRefreshMutationVariables>(TokenRefreshDocument, options);
      }
export type TokenRefreshMutationHookResult = ReturnType<typeof useTokenRefreshMutation>;
export type TokenRefreshMutationResult = Apollo.MutationResult<TokenRefreshMutation>;
export type TokenRefreshMutationOptions = Apollo.BaseMutationOptions<TokenRefreshMutation, TokenRefreshMutationVariables>;
export const LogOutDocument = gql`
    mutation LogOut {
  logOut
}
    `;
export type LogOutMutationFn = Apollo.MutationFunction<LogOutMutation, LogOutMutationVariables>;

/**
 * __useLogOutMutation__
 *
 * To run a mutation, you first call `useLogOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOutMutation, { data, loading, error }] = useLogOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogOutMutation(baseOptions?: Apollo.MutationHookOptions<LogOutMutation, LogOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOutMutation, LogOutMutationVariables>(LogOutDocument, options);
      }
export type LogOutMutationHookResult = ReturnType<typeof useLogOutMutation>;
export type LogOutMutationResult = Apollo.MutationResult<LogOutMutation>;
export type LogOutMutationOptions = Apollo.BaseMutationOptions<LogOutMutation, LogOutMutationVariables>;